__turbopack_context__.v({
  "carousel": "PzytBG_carousel",
  "logo": "PzytBG_logo",
  "scroll": "PzytBG_scroll",
  "track": "PzytBG_track",
});
